import axios, { AxiosRequestConfig } from 'axios';
import router from '../router';
// import store from '../store/index';
import { Toast } from 'vant';
import storage from 'good-storage';
import qs from 'qs';

/**
 * 切换环境
 * 切换API baseURL
 */
const baseUrl = process.env.VUE_APP_API_PATH;
const authenticationCenterUrl = process.env.VUE_APP_AUTHENTICATION_CENTER_API_PATH;
const dataCenterUrl = process.env.VUE_APP_DATA_CENTER_API_PATH;
const dataCenterKey = process.env.VUE_APP_DATA_CENTER_APPKEY;

/**
 * 提示函数
 * 禁止点击蒙层、显示一秒后关闭
 */
const tip = (msg: any) => {
    Toast({
        message: msg,
        duration: 1000,
        forbidClick: true
    });
};

/**
 * 跳转登录页
 * 携带当前页面路由，以期在登录页面完成登录后返回当前页面
 */
const toLogin = () => {
    router.replace({
        path: '/',
        query: {
            redirect: router.currentRoute.fullPath
        }
    });
};

/**
 * 请求失败后的错误统一处理
 * @param {Number} status 请求失败的状态码
 */
const errorHandle = (status: number, other: any) => {
    // 状态码判断
    switch (status) {
        // 401: 未登录状态，跳转登录页
        case 401:
            tip('请重新登录');
            setTimeout(() => {
                toLogin();
            }, 1000);
            break;
        // 403 token过期
        // 清除token并跳转登录页
        case 403:
            tip('登录已过期，请重新登录');
            storage.remove('AUTHTOKEN'); // 清除缓存中的token，再次登录重新存储
            // store.commit('loginSuccess', null); // 同步存储登录状态
            setTimeout(() => {
                toLogin();
            }, 1000);
            break;
        // 404 请求不存在
        case 404:
            tip('请求的资源不存在');
            break;
        default:
        // console.log(other);
    }
};

// 创建axios实例
// const instance = axios.create({
//     timeout: 1000 * 12
// });
const instance = axios;
instance.defaults.timeout = 1000 * 20;

// 允许跨域
// instance.defaults.withCredentials = true;

// 设置post请求头
instance.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';

/**
 * 请求拦截器
 * 每次请求前，如果存在token则在请求头中携带token
 */
instance.interceptors.request.use(
    req => {
        // 登录流程控制中，根据本地是否存在token判断用户的登录情况
        // 即使token存在，也有可能token是过期的，所以在每次的请求头中携带token
        const token = storage.get('AUTHTOKEN');
        if (token) {
            req.headers.Authorization = token;
        }

        // 登录时判断本地是否存在OAtoken，若存在，则加入到header中
        const OAtoken = storage.get('OAtoken');
        if (OAtoken) {
            req.headers.OAToken = OAtoken;
        }

        // token && (req.headers.Authorization = token);
        return req;
    },
    err => Promise.reject(err));

/**
 * 响应拦截器
 */
instance.interceptors.response.use(
    // 请求成功
    res => {
        const resCode = String(res.status);
        if (resCode.substr(0, 1) === '2') {
            return Promise.resolve(res)
        } else {
            return Promise.reject(res)
        }
    },
    // 请求失败
    error => {
        let errorMsg = ['异常错误，请刷新后重试。'];

        const { response } = error;
        if (response) {
            if (response.data.errorMessages) {
                errorMsg = response.data.errorMessages;
            } else {
                errorMsg = response.data.error;
            }
            // 请求已发出，但是不在2xx的范围
            errorHandle(response.status, errorMsg);
            // return Promise.reject(errorMsg);
        } else if (error.message.includes('Network Error')) {
            // 处理断网的情况
            // eg:请求超时或断网时，更新state的network状态
            // eg:network状态在app.vue中控制着一个全局的断网提示组件的显示隐藏
            // store.commit('changeNetwork', false);
            errorMsg = ['网络连接失败！'];
        }
        return Promise.reject(errorMsg);

    }
);

// 认证中心
const AuthenticationCenterAxios = (method: string, url: any, data: any) => {
    let res: any;
    instance.defaults.baseURL = authenticationCenterUrl;
    if (method === 'GET') {
        res = instance.get(url, { params: data });
    } else if (method === 'POST') {
        res = instance.post(url, data);
    }
    return new Promise((resolve) => {
        if (res === 'Error: Network Error') {
            resolve({
                'AllMessages': '网络连接失败！',
                'Data': null,
                'HasErrors': true,
                'Messages': ['网络连接失败！'],
                'Success': false,
            });
        } else {
            resolve(res);
        }
    });
};

// 数据中心
const DataCenterAxios = (method: string, url: any, data: any) => {
    let res: any;
    instance.defaults.baseURL = dataCenterUrl;
    const dataUrl = url + '?appKey=' + escape(dataCenterKey)
    if (method === 'GET') {
        res = instance.get(dataUrl, { params: data });
    } else if (method === 'POST') {
        res = instance.post(dataUrl, data);
    }
    return new Promise((resolve) => {
        if (res === 'Error: Network Error') {
            resolve({
                'AllMessages': '网络连接失败！',
                'Data': null,
                'HasErrors': true,
                'Messages': ['网络连接失败！'],
                'Success': false,
            });
        } else {
            resolve(res);
        }
    });
};

// handle
const handleAxios = (method: string, url: any, data: any, success: any, failure: any) => {
    let res: any;
    instance.defaults.baseURL = baseUrl;
    if (method === 'GET') {
        res = instance.get(url, { params: data });
    } else if (method === 'POST') {
        res = instance.post(url, data);
    }
    res.then((val: any) => {
        if (success) {
            success(val.data)
        }
        else {
            failure(val.data)
        }
    })
        .catch((err: any) => {
            console.log('+++' + err)
        })
}


// 异步请求（审批大厅）
const http = async (method: string, url: any, data: any) => {
    let res: any;
    if (url.indexOf('http') !== -1) {
        instance.defaults.baseURL = '';
    }
    else {
        instance.defaults.baseURL = baseUrl;
    }
    if (method === 'GET') {
        // 参数序列化
        res = await instance.get(url, { params: data, paramsSerializer: params => {
            return qs.stringify(params, { indices: false })
          } });
    } else if (method === 'POST') {
        res = await instance.post(url, data);
    } else if (method === 'DELETE') {
        res = await instance.delete(url, { params: data });
    } else if (method === 'PUT') {
        res = await instance.put(url, data);
    }
    return new Promise((resolve) => {
        if (res === 'Error: Network Error') {
            resolve({
                'AllMessages': '网络连接失败！',
                'Data': null,
                'HasErrors': true,
                'Messages': ['网络连接失败！'],
                'Success': false,
            });
        } else {
            res = res.data;
            resolve(res);
        }
    });
};


/**
 * @param {String} url     请求的url
 * @param {Object} data    请求的参数
 */
export default {
    handleGetToken(url: any, params: any, success: any, failure: any) {
        return handleAxios('GET', url, params, success, failure);
    },
    async AuthenticationCenterPost(url: any, data: any) {
        return AuthenticationCenterAxios('POST', url, data);
    },
    async DataCenterGet(url: any, data: any) {
        return DataCenterAxios('GET', url, data);
    },
    async httpGet(url: any, data: any) {
        return http('GET', url, data);
    },
    async httpPost(url: any, data: any) {
        return http('POST', url, data);
    },
    async httpDelete(url: any, data: any) {
        return http('DELETE', url, data);
    },
    async httpPut(url: any, data: any) {
        return http('PUT', url, data);
    },

};
